import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useCookies } from '@vueuse/integrations/useCookies'
import { useUserStore } from '@/stores/userStore'
import { useStripePortal } from '@/composables/useStripePortal'

export const usePaywallStore = defineStore('paywall', () => {
  const isPaywall = ref(false)
  const paywallText = ref('')
  const userStore = useUserStore()
  const { redirectToPortal } = useStripePortal()

  const redirectContactOrStripe = () => {
    const accountType = userStore.user.organisation.accountType
    const hasStripeCustomer =
      userStore.subscriptionStatus?.hasStripeCustomer ??
      !!userStore.user.organisation.stripeCustomerID

    // Only org admins can buy/manage seats directly.
    if (!userStore.isOrgaAdmin) {
      return (window.location.href = 'https://newsrooms.ai/contact')
    }

    if (accountType === 'ENTERPRISE' || accountType === 'FREE') {
      return (window.location.href = 'https://newsrooms.ai/contact')
    }

    if (hasStripeCustomer) {
      return redirectToPortal()
    }

    // SELF_SERVICE without customer yet -> bootstrap through checkout.
    return (window.location.href = '/checkout')
  }

  const redirectProductPage = () => {
    return (window.location.href = 'https://newsrooms.ai/contact')
  }
  const triggerPaywall = (text?: string) => {
    isPaywall.value = true
    paywallText.value =
      text ||
      'You have reached the limit of your license. Please contact your administrator to upgrade your license.'
  }

  const cookies = useCookies(['hasUsedTranscription', 'hasUsedFileExtraction'])
  const checkAndSetTranscribeCookie = () => {
    if (cookies.get('hasUsedTranscription')) {
      return true
    } else {
      cookies.set('hasUsedTranscription', true, {
        expires: new Date(Date.now() + 30 * 24 * 60 * 5 * 1000)
      })
      return false
    }
  }
  const checkAndSetFileExtractionCookie = () => {
    if (cookies.get('hasUsedFileExtraction')) {
      return true
    } else {
      cookies.set('hasUsedFileExtraction', true, {
        expires: new Date(Date.now() + 30 * 24 * 60 * 5 * 1000)
      })
      return false
    }
  }
  return {
    triggerPaywall,
    isPaywall,
    paywallText,
    redirectProductPage,
    redirectContactOrStripe,
    checkAndSetTranscribeCookie,
    checkAndSetFileExtractionCookie
  }
})
